import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    container: 'f-col p-4 space-y-2 lg:space-y-4',
    ctaContainer: 'f-col gap-4 not-first:pt-4 md:(flex-row wrap) lg:gap-6'
  }
} satisfies CMSConfig['linkedCard']
